var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "document-section"
  }, [_c('h3', {
    staticClass: "fs-16 fw-bold clr-title mb-4"
  }, [_vm._v("Uploaded Documents")]), _vm.loading ? _c('div', {
    staticClass: "text-center p-4"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "row"
  }, [_vm.documents.length === 0 ? _c('div', {
    staticClass: "text-center p-4 text-muted"
  }, [_vm._v(" No documents available ")]) : _vm._l(_vm.documents, function (file, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-6 col-lg-4 mb-4"
    }, [_c('div', {
      staticClass: "ticket_documentInfo d-flex align-items-center gap-3 h-100"
    }, [_vm._m(1, true), _c('div', {
      staticClass: "document_content d-flex flex-column gap-1 flex-grow-1"
    }, [_c('a', {
      staticClass: "document_link d-flex align-items-center gap-1 justify-content-between",
      attrs: {
        "href": file.url,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "document_name clr-primary fw-semibold text-truncate text-nowrap"
    }, [_vm._v(_vm._s(file.original_file_name))]), _vm._m(2, true)]), _c('div', {
      staticClass: "document_info d-flex align-items-center gap-2 flex-wrap font-14"
    }, [_c('span', {
      staticClass: "dots"
    }), _c('span', {
      staticClass: "document_datewrapper clr-title fw-medium"
    }, [_vm._v(" Uploaded : "), _c('span', {
      staticClass: "document_date clr-bold-grey fw-normal"
    }, [_vm._v(_vm._s(_vm.formatDate(file.updated_at)))])])])])])]);
  })], 2)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "spinner-border",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading comments...")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "icon-wrapper flex-shrink-0"
  }, [_c('img', {
    staticClass: "w-100 h-100",
    attrs: {
      "src": require("./../../../assets/images/quotes.svg"),
      "alt": "pdf icon"
    }
  })]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "link_icon d-flex align-items-center justify-content-center clr-primary font-14"
  }, [_c('i', {
    staticClass: "fa-solid fa-arrow-up-right-from-square"
  })]);
}]

export { render, staticRenderFns }